import React, { Component } from "react";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables-bitozen";
import LoadingBar from "react-top-loading-bar";
import PopUp from "../../../pages/PopUpAlert";
import API from "../../../../Services/Api";
import { checkResponseError } from "../../../../Services/Utils";
import { connect } from "react-redux";
import * as R from "ramda";
import { Redirect } from "react-router-dom";
import AuthAction from "../../../../Redux/AuthRedux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import SimpleDate from "../../../../modules/SimpleDate";
import M from "moment";

import FormRequest from "./formRequest";
import DDLCompany from "../../../../modules/commons/DDLCompany";
import SimpleInput from "../../../../modules/SimpleInput";

import Button from "../../../../modules/commons/Button";
import moment from "moment";
import SimpleSearch from "../../../../modules/SimpleSearch";
import SimpleInputRow from "../../../../modules/SimpleInputRow";
import FormMovement from "./formMovement";
const UtilsButtonLogin = require("../../../../Services/UtilsButtonLogin");

const ct = require("../../../../modules/custom/customTable");
const getMuiTheme = () => createMuiTheme(ct.customTable());
const options = ct.customOptions6();

class unitMovementh3 extends Component {
  constructor() {
    super();
    this.state = {
      rawData: [],
      // dataTable:[],
      dataTable: [
        ["1", "Request 1", "11-09-2024", "EKSAD", "69", "Done"],
        ["2", "Request 2", "15-10-2024", "ABC Corp", "85", "Done"],
        ["3", "Request 3", "22-11-2024", "Tech Solutions", "47", "Done"],
        ["4", "Request 4", "03-12-2024", "Global Innovations", "92", "Done"],
        ["5", "Request 5", "19-01-2025", "Dynamic Services", "76", "Done"],
        ["6", "Request 6", "28-02-2025", "Prime Industries", "58", "Done"],
        ["7", "Request 7", "09-03-2025", "Infinite Ventures", "63", "Done"],
        ["8", "Request 8", "14-04-2025", "Optimal Solutions", "71", "Done"],
      ],
      dataTable2: [
        ["1", "Movement 1", "Req 1", "11-09-2024", "EKSAD", "69", "Done"],
        ["2", "Movement 2", "Req 2", "15-10-2024", "ABC Corp", "85", "Done"],
        ["3", "Movement 3", "Req 3", "22-11-2024", "Tech Solutions", "47", "Done"],
        ["4", "Movement 4", "Req 4", "03-12-2024", "Global Innovations", "92", "Done"],
        ["5", "Movement 5", "Req 5", "19-01-2025", "Dynamic Services", "76", "Done"],
        ["6", "Movement 6", "Req 6", "28-02-2025", "Prime Industries", "58", "Done"],
        ["7", "Movement 7", "Req 7", "09-03-2025", "Infinite Ventures", "63", "Done"],
      ],
      selectedIndex: [],
      createVisible: false,
      updateVisible: false,
      deletePopUpVisible: false,
      savePopUpVisible: false,
      loadSave: false,
      allowResize: false,
      defaultSize: 0,
      minSize: 0,
      maxSize: 0,
      timeout: 1000 * 100 * 9,
      isTimedOut: false,
      toCount: 0,
      table_limit: 10,
      table_page: 0,
      table_query: "",
      createVisible2: false,
      tabIndex: 0,
      checkTab: false,
      data: {},
      dataDto: {},
      buttonAccess: {},
    };
    this.idleTimer = null;
  }

  logout() {
    this.props.authLogout();
    return <Redirect to={{ pathname: "/" }} />;
  }

  onAction() {
    this.setState({ isTimedOut: false });
  }

  onActive() {
    this.setState({ isTimedOut: false });
  }

  onIdle() {
    const isTimedOut = this.state.isTimedOut;
    if (isTimedOut) {
      alert("Your session has timed out. Please log in again");
      this.logout();
    } else {
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  componentDidMount() {
    UtilsButtonLogin.buttonAccess("MASTER-022", (response) => {
      // console.log("ORI ", response);
      this.setState(
        {
          buttonAccess: response,
        },
        () => {
          this.getCountPage(this.state.table_page, this.state.table_limit);
        }
      );
    });
  }

  getCountPage = async (page, limit) => {
    let payload = {
      limit: limit,
      offset: page,
      filter: this.state.table_query,
      companyId: this.state.dataDto.companyId,
      companyGroupId: null,
      category: null,
      isActive: null,
      sortBy: this.state.dataDto.sortBy ?? "",
      orderBy: this.state.dataDto.orderBy ?? "",
    };

    let res = await API.create("LOCAL_DELIVERY").getDelivery(payload);
    if (res.ok) {
      if (res.data.data === null) {
        this.setState({ dataTable: [] });
      } else {
        // console.log(JSON.stringify(res.data.data, null, 2));
        let dataTable =
          res.data.data &&
          res.data.data.map((value) => {
            const {
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            } = value;
            return [
              noid,
              nospk,
              namacustomer,
              tgldelivery,
              unittype,
              warna,
              noka,
              nosin,
              nopickship,
            ];
          });
        console.log("datatable", dataTable);
        this.setState({
          rawData: res.data.data && res.data.data.listUser,
          dataTable,
          toCount: res.data.data && res.data.data.dataOfRecord,
        });
        this.onFinishFetch();
      }
    }
  };

  handleClearUser = (e) => {
    this.setState(
      {
        table_page: 0,
        toCount: 0,
        data: {},
        dataDto: {},
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  handleSearch = (eventSearch) => {
    this.setState(
      {
        table_page: 0,
        dataDto: eventSearch ? this.state.data : this.state.dataDto,
      },
      () => {
        this.getCountPage(this.state.table_page, this.state.table_limit);
      }
    );
  };

  isLoad(visible) {
    this.setState({ loadSave: visible });
  }

  checkResponse(res, type) {
    if (res.ok && res.data.status === "S") {
      type === "delete" && this.setState({ deletePopUpVisible: false });
      setTimeout(() => {
        this.openSavePopUp();
      }, 500);
    } else {
      this.isLoad(false);
      checkResponseError(res);
    }
  }

  handleSubmit = async (response) => {
    this.checkResponse(response);
  };

  handleDelete = async () => {
    this.isLoad(true);
    let payload = { ...this.state.rawData[this.state.selectedIndex] };
    payload.action = "DELETE";

    let response = await API.create("MASTERDATA_EKSAD").postSaveUser(payload);
    this.checkResponse(response, "delete");
    this.isLoad(false);
  };

  handlePopUp = () => {
    this.handleSearch();
    this.setState({
      savePopUpVisible: false,
      createVisible: false,
      createVisible2: false,
    });
  };

  onChangeDate = (e, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: M(e).format("DD-MM-YYYY"),
      },
    });
  };

  startFetch = () => {
    this.LoadingBar.continousStart();
  };

  onFinishFetch = () => {
    if (typeof this.LoadingBar === "object") this.LoadingBar.complete();
  };

  openCreateForm = () => {
    this.setState({ createVisible: !this.state.createVisible });
  };
  openCreateForm2 = () => {
    this.setState({ createVisible2: !this.state.createVisible2 });
  };


  openUpdateForm = () => {
    this.setState({ updateVisible: !this.state.updateVisible });
  };

  openSavePopUp = () => {
    this.setState({
      savePopUpVisible: !this.state.savePopUpVisible,
      loadSave: false,
    });
  };

  openDeletePopup = (index) => {
    this.setState({
      deletePopUpVisible: !this.state.deletePopUpVisible,
      selectedIndex: index,
    });
  };

  columnsMovement = [
    { name: "No" },
    { name: "No. Movement" },
    { name: "No. Request" },
    { name: "Tgl Moving" },
    { name: "From" },
    { name: "Qty Unit" },
    { name: "Status" },

    {
      name: "Aksi",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage(
                  "slide-menu-1",
                  tableMeta.rowIndex,
                  "companyGroup"
                )}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>

              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage("slide-menu-view", tableMeta.rowIndex)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-print"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  columnsUser = [
    { name: "No" },
    { name: "No. Request" },
    { name: "Tgl Reequest" },
    { name: "To" },
    { name: "Qty Unit" },
    { name: "Status" },

    {
      name: "Aksi",
      options: {
        customBodyRender: (val, tableMeta) => {
          return (
            <div style={{ width: "115px" }}>
              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage(
                  "slide-menu-1",
                  tableMeta.rowIndex,
                  "companyGroup"
                )}
                permission=""
              >
                <i
                  className="fa fa-lw fa-pencil-alt"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>

              <Button
                className="btnAct"
                style={{ marginRight: 15, backgroundColor: "transparent" }}
                onClick={this.opSidePage("slide-menu-view", tableMeta.rowIndex)}
                permission=""
              >
                <i
                  className="fa fa-lw fa-print"
                  style={{
                    backgroundColor: "transparent",
                    color: "red",
                    fontSize: 20,
                  }}
                />
              </Button>
            </div>
          );
        },
      },
    },
  ];

  onchangeInput = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
    });
  };

  opSidePage = (menu, data) => (e) => {
    e.preventDefault();
    let selectedIndex = data;
    this.setState({
      updateVisible: false,
    });

    switch (menu) {
      case "slide-menu-1":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "update",
        });
        break;
      case "slide-menu-view":
        this.setState({
          updateVisible: true,
          selectedIndex,
          popupType: "view",
        });
        break;
      default:
        break;
    }
  };
  resetTab = (tabIndex) => {
    this.setState({ tabIndex });
    if (tabIndex === 0) {
      this.getCountPage(this.state.table_page, this.state.table_limit);
    }
  };

  render() {
    if (R.isNil(this.props.auth.user))
      return <Redirect to={{ pathname: "/" }} />;
    let { toCount, table_query } = this.state;
    let tableOptions = {
      ...options,
      // serverSide: true,
      filter: false,
      count: toCount,
      searchText: table_query,
      search: false,
      viewColumns: false,
      rowsPerPage: this.state.table_limit,
      page: this.state.table_page,
      onColumnSortChange: (changedColumn, direction) => {
        let order = "desc";
        if (direction === "ascending") {
          order = "asc";
        }

        let columnOrder = "";

        if (changedColumn === "Company") {
          columnOrder = "companyCode";
        }

        if (changedColumn === "Username") {
          columnOrder = "username";
        }

        if (changedColumn === "Email") {
          columnOrder = "email";
        }

        if (changedColumn === "Category") {
          columnOrder = "category";
        }

        if (changedColumn === "Employee Name") {
          columnOrder = "name";
        }

        if (changedColumn === "Status") {
          columnOrder = "status";
        }

        this.columnsUser.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });
        this.columnsMovement.map((value, index) => {
          if (changedColumn === value.name && value.name !== "Action") {
            value.options = { sortDirection: order };
          } else {
            value.options = { ...value.options, sortDirection: "none" };
          }
        });

        this.setState(
          {
            dataDto: {
              ...this.state.dataDto,
              sortBy: columnOrder,
              orderBy: order,
            },
          },
          () => {
            this.getCountPage(this.state.table_page, this.state.table_limit);
          }
        );
      },
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.setState({ table_page: tableState.page });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.setState({ table_limit: tableState.rowsPerPage });
            this.getCountPage(tableState.page, tableState.rowsPerPage);
            break;
          case "search":
            let searchText = tableState.searchText ? tableState.searchText : "";
            this.setState({ table_query: searchText }, () => {
              this.handleSearch();
            });
            break;
          default:
            break;
        }
      },
    };
    return (
      <div className="main-slider">
        <div className="padding-tbl-monitoring">
          <LoadingBar onRef={(ref) => (this.LoadingBar = ref)} />
          <Tabs
            selectedIndex={this.state.tabIndex}
            onSelect={(tabIndex) => this.resetTab(tabIndex)}
          >
            <TabList>
              <Tab>Request</Tab>
              <Tab>Movement</Tab>
            </TabList>
            <TabPanel>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    type="button"
                    style={{ width: "200px" }}
                    className="btn btn-plus background-red margin-left-15px"
                    valueCombo={this.state.data.companyIdSelect}
                    onClick={this.openCreateForm.bind(this)}
                  >
                    <span>
                      <i
                        className="fa fa-plus"
                        style={{ marginRight: "10px" }}
                      />
                      NEW REQUEST
                    </span>
                  </Button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      marginRight: "15px",
                      marginLeft: "15px",
                      marginTop: "5px",
                    }}
                  >
                    <SimpleDate
                      date={this.state.data.startDate}
                      minDate={new Date()}
                      backdates
                      onChange={(date) => this.onChangeDate(date, "startDate")}
                    />
                  </div>
                  <div style={{ marginTop: "8px" }}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-filter"
                          style={{ marginRight: "10px" }}
                        />
                        Filter
                      </span>
                    </Button>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      marginTop: "5px",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    <div style={{ width:200, marginRight: "15px", marginLeft: "15px" }}>
                      <DDLCompany
                        // label={"No SL"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                    </div>

                    <div>
                      <SimpleInput
                        name="Parts"
                        value={this.state.data.Parts}
                        onChange={this.onchangeInput}
                      />
                    </div>
                  </div>

                  <div style={{ width: 200, marginTop: "8px", marginLeft: "15px" }}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-search"
                          style={{ marginRight: "10px" }}
                        />
                        Search
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Request Table"}
                    subtitle={"Setting data of Request"}
                    data={this.state.dataTable}
                    columns={this.columnsUser}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
            </TabPanel>
            <TabPanel>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    type="button"
                    style={{ width: "200px" }}
                    className="btn btn-plus background-red margin-left-15px"
                    valueCombo={this.state.data.companyIdSelect}
                    onClick={this.openCreateForm2.bind(this)}
                  >
                    <span>
                      <i
                        className="fa fa-plus"
                        style={{ marginRight: "10px" }}
                      />
                      NEW MOVEMENT
                    </span>
                  </Button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      marginRight: "15px",
                      marginLeft: "15px",
                      marginTop: "5px",
                    }}
                  >
                    <SimpleDate
                      date={this.state.data.startDate}
                      minDate={new Date()}
                      backdates
                      onChange={(date) => this.onChangeDate(date, "startDate")}
                    />
                  </div>
                  <div style={{ marginTop: "8px" }}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red margin-left-15px"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-filter"
                          style={{ marginRight: "10px" }}
                        />
                        Filter
                      </span>
                    </Button>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: 400,
                      marginTop: "5px",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                  >
                    <div style={{ width:200, marginRight: "15px", marginLeft: "15px" }}>
                      <DDLCompany
                        // label={"No SL"}
                        box={"search"}
                        hierarchy={false}
                        onChangeCombo={(value) => {
                          this.setState({
                            data: { ...this.state.data, ...value },
                          });
                        }}
                        valueCombo={this.state.data.companyIdSelect}
                      />
                    </div>

                    <div>
                      <SimpleInput
                        name="Parts"
                        value={this.state.data.Parts}
                        onChange={this.onchangeInput}
                      />
                    </div>
                  </div>

                  <div style={{ width: 200, marginTop: "8px", marginLeft: "15px" }}>
                    <Button
                      type="button"
                      style={{ width: "130px" }}
                      className="btn btn-plus background-red"
                      valueCombo={this.state.data.companyIdSelect}
                      onClick={this.openCreateForm.bind(this)}
                    >
                      <span>
                        <i
                          className="fa fa-search"
                          style={{ marginRight: "10px" }}
                        />
                        Search
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    key={toCount}
                    title={"Movement Table"}
                    subtitle={"Setting data of Movement"}
                    data={this.state.dataTable2}
                    columns={this.columnsMovement}
                    options={tableOptions}
                    // buttonCreate={this.state.buttonAccess.btnAdd}
                    // onCreate={this.openCreateForm.bind(this)}
                  />
                </MuiThemeProvider>
              </div>
            </TabPanel>
          </Tabs>
          <div
            style={{ float: "right", marginRight: "1vw" }}
            className="padding-top-30px padding-bottom-20px"
          >
            {/* <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
            >
              <span>BACK</span>
            </button>
            <button
              style={{ marginLeft: "15px" }}
              className="btn btn-back"
              type="button"
              onClick={this.openCreateForm.bind(this)}
            >
              <span>PROCCESS</span>
            </button> */}
          </div>
        </div>

        <div>
          {this.state.createVisible && (
            <FormRequest
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible && (
            <FormRequest
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.createVisible2 && (
            <FormMovement
              type={"create"}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openCreateForm2.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.updateVisible2 && (
            <FormMovement
              type={this.state.popupType === "update" ? "edit" : "view"}
              data={this.state.rawData[this.state.selectedIndex]}
              loadSave={this.state.loadSave}
              user={this.props.auth.user}
              onClickClose={this.openUpdateForm.bind(this)}
              onClickSave={this.handleSubmit.bind(this)}
            />
          )}

          {this.state.savePopUpVisible && (
            <PopUp
              type={"save"}
              class={"app-popup app-popup-show"}
              onClick={this.handlePopUp.bind(this)}
            />
          )}

          {this.state.deletePopUpVisible && (
            <PopUp
              type={"delete"}
              class={"app-popup app-popup-show"}
              onClickDelete={this.handleDelete}
              onClick={this.openDeletePopup}
              isLoading={this.state.loadSave}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    h1Module: state.h1Module,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(unitMovementh3);
